export default "__VITE_ASSET__Ca$5L_VM__"